if($('.category-top').length){
    $('.category-top').append($('.usp.kategorie'))
}

if($('.type-category').length){
    if($('.usp.kategorie').length){
        var currentPath = window.location.pathname;
        $('.usp.kategorie').each(function() {
            if ($(this).attr('data-url') === currentPath) {
               
            } else {
                $(this).remove();
            }
        });
    }
}

$(document).on('click', '.readMore', function(){
    var scrollTo = $(this).data('scrool');
        if ($(scrollTo).length) {
            $('html, body').animate({
                scrollTop: $(scrollTo).offset().top
            }, 1000);
        } else {
            console.error("Cílový element nebyl nalezen: " + scrollTo);
        }

        return false;
})


if($('.type-category').length){
    function MhCategory(){
        if(!$('.category-header .filters-unveil-button-wrapper').length){
            $('.filters-unveil-button-wrapper').clone().appendTo('.category-header')
        }
        if(!$('#filters-wrapper #filters .close').length){
            $('#filters-wrapper #filters').prepend('<span class="close"></span>')
        }
    }
    $(document).ready(function(){
        MhCategory()
    })
    document.addEventListener('ShoptetDOMContentLoaded', function () {
        MhCategory()
    });
}

$(document).on('click', 'span.close', function(){
$('.filters-unveil-button-wrapper a').trigger('click')
$('#filters').removeClass('visible')
$('body').removeClass('.filters-visible')
})

